export default class MapTagsData {
    static mapTagsListByModule(record) {
        if (record) {
            return {
                id: record.tagId,
                name: record.name,
                description: record.description,
                module: record.module,
                priority: record.priority,
                color: record.color,
                active: record.active,
                createdBy: record.createdBy,
                createdOn: record.createdOn,
                modifiedBy: record.modifiedBy,
                modifiedOn: record.modifiedOn,
            };
        }

        return {};
    }

    static mapListByModule(record) {
        if (record) {
            return {
                id: record.TagId,
                name: record.Name,
                description: record.Description,
                priority: record.Priority,
                color: record.Color,
            };
        }

        return {};
    }

    static mapEditingTag(data) {
        if (data) {
            return {
                Name: data.name,
                Description: data.description,
                Module: data.module,
                Priority: data.priority,
                Color: data.color,
                Active: data.active,
            };
        }

        return {};
    }
}
